import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { Color } from '@diritto/common/style/color';
import styled from '@emotion/styled';
import { getTextLineStyle } from 'styles/common';
import { Link } from 'ui-components/common/Link';

export const ProfileName = ({ profile, className }: { profile?: ProfileLitePublicRelayDto; className?: string }) =>
  profile ? (
    <Link href={`/accounts/profiles/${profile.id}`} className={className}>
      <StyledProfileNickname>{profile.nickname}</StyledProfileNickname>
    </Link>
  ) : (
    <BlindProfileName className={className} />
  );

export const BlindProfileName = styled.div`
  display: flex;
  width: 32px;
  height: 14px;
  align-self: center;
  color: ${Color.Gray200};
  background-color: ${Color.Gray200};
`;

const StyledProfileNickname = styled.div`
  ${getTextLineStyle(1)};
`;
